import { itixShowController } from '@x-com/pwitixcomm/tslib/itix.show.ts'

export const initShowStatus = async () => {
    const showIds: string[] = Array.from(new Set(Array.from(document.querySelectorAll('[data-showid]')).map((el) => el.dataset.showid)))

    if (showIds.length > 0) {
        const formData = new FormData()

        showIds.forEach((showId) => {
            formData.append('show_ids[]', showId)
        })

        const data = await itixShowController.getStatus(formData)

        if (data.status === 'OK') {
            Object.entries(data.message.shows)?.forEach(([showId, showData]) => {
                document.querySelectorAll(`[data-showid="${showId}"]`).forEach((el) => {
                    if (el) {
                        const span = el.querySelector('span')
                        const status = el.getAttribute('data-status')

                        // If presale_start is set, the show is in friends-only presale
                        // and non-friends should not see the order button
                        if (showData.presale_start) {
                            return
                        }

                        // Handle show-tile last-tickets label: only reveal when itix status is 'bestel'
                        if (el.getAttribute('data-label') === 'lastTickets') {
                            if (showData.status === 'bestel') {
                                el.classList.remove('hide')
                            } else if (el && window.orderTranslations[showData.status]) {
                                el.classList.remove('hide')
                                el.innerHTML = window.orderTranslations[showData.status]
                            }

                            return
                        }

                        if (span && window.orderTranslations[showData.status]) {
                            el.classList.remove('hide')
                            span.innerHTML = showData.status === 'bestel' ? status : window.orderTranslations[showData.status]
                            //Uitverkocht / geannuleerd / noSale
                            if (
                                window.orderTranslations[showData.status] === 'Geannuleerd' ||
                                window.orderTranslations[showData.status] === 'Geen verkoop'
                            ) {
                                el.setAttribute('disabled', '')
                                el.setAttribute('tabindex', '-1')
                            }
                        }
                    }
                })
            })
        }
    }
}
